































import { Vue, Component, Prop } from 'vue-property-decorator'
import { TableList } from '@/shims-global'
import MainTitle from '../_components/MainTitle.vue'
import SubTitle from '../_components/SubTitle.vue'
import Page1Chart1 from '../_components/charts/Page1Chart1.vue'

@Component({
  components: {
    MainTitle,
    SubTitle,
    Page1Chart1
  }
})
export default class extends Vue {
  @Prop({ required: true }) private title!: string
  @Prop({}) private data!: any
  private list: any = []

  created() {
    this.list = this.data.energyZoneScorePercentVos
    this.list.map((v, index) => {
      v.xNames = []
      v.normData = []
      v.data = []
      v.vos.map(q => {
        v.xNames.push(q.scoreTypeIntro)
        v.normData.push(q.normPercent)
        v.data.push(q.percentStr)
      })
    })
  }
}
